import React, {memo} from "react";
import {ItemTypes} from "../../../constants";
import {makeStyles} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        margin: 10,
        padding: 10,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'center',
        verticalAlign: 'middle',
        border: '1px solid #c9b586',
        borderRadius: 10,
    },
    text: {
        minWidth: 150,
        marginRight: 10
    },
    img: {
        width: '20vw',
        // height: '10vw'
    },
    button: {
        color: '#fff'
    }
})

const ModerationItem = ({item, index, onApprove, onReject}) => {
    const classes = useStyles()

    return (<div className={classes.root}>
        <span className={classes.text}>{index + 1}</span>

        {item.type === ItemTypes.MESSAGE ?
            <span className={classes.text}>{item.data}</span> :
            <img src={item.data} className={classes.img} alt={'No image'}/>}
        <span className={classes.text}>{new Date(item.timestamp).toLocaleString()}</span>

        {item.likes && <Typography>{item.likes.length} likes</Typography>}

        {!item.author ? 'Unknown user' : (item.author.FirstName + item.author.LastName)}

        {onApprove && <button className={'yellow-md-button ' + classes.button}
                              onClick={() => onApprove(item.id)}>
            Approve
        </button>}
        {onReject && <button className={'yellow-md-button active ' + classes.button}
                             onClick={() => onReject(item.id)}>
            Reject
        </button>}
    </div>);
}

export default memo(ModerationItem)